import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Destroyable, isSomething } from '@tokeet-frontend/tv3-platform'
import { DataDictionaryDialogService } from '@tv3/shared/data-dictionary-dialog/data-dictionary-dialog.service'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-editor-plaintext',
  templateUrl: './editor-plaintext.component.html',
  styleUrls: ['./editor-plaintext.component.scss'],
})
export class EditorPlaintextComponent extends Destroyable implements OnInit {
  @Input() contentCtrl: FormControl

  constructor(private dataDictionaryDialog: DataDictionaryDialogService) {
    super()
  }

  ngOnInit() {}

  onDataDictionary() {
    this.dataDictionaryDialog
      .open()
      .pipe(filter(isSomething))
      .subscribe((tag) => {
        this.contentCtrl.setValue(this.contentCtrl.value + tag)
      })
  }
}
